import React from 'react';
import BFLButton from '@repo/shared-ui/BFLButton';
import type { NewsAEMImages } from '../../interfaces/NewsAEM.interface';
import Image from "next/image";
import { getFullUrl } from '../../utils/helper';

const DEFAULT_NO_RESULTS_IMAGE =
  "https://cms-assets.bajajfinserv.in/is/image/bajajfinance/no-stocks";

interface NoResultsFoundProps {
  title?: string;
  description?: string;
  aemImages?: NewsAEMImages;
  buttonText?: string;
  buttonIcon?: string;
  onButtonClick?: () => void;
}

const NoResultsFound: React.FC<NoResultsFoundProps> = ({
  title = "No results found",
  description,
  aemImages,
  buttonText,
  buttonIcon,
  onButtonClick = () => {},
}) => {
  const imageSrc = aemImages?.noResultsImage ?? DEFAULT_NO_RESULTS_IMAGE;

  return (
    <div className="flex flex-col items-center justify-center px-5 py-12 min-h-[400px]">
      {/* Image Illustration */}
      <div className="mb-6">
        <Image
          width={180}
          height={180}
          src={getFullUrl(imageSrc)}
          alt="No results found"
          className="mx-auto w-[180px] h-[180px] max-sm:w-[94.67px] max-sm:h-[110.9px]"
          loading="lazy"
          aria-hidden="true"
        />
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-black mb-2 text-center">
        {title}
      </h3>

      {/* Description */}
      <p className="text-sm text-gray-600 text-center max-w-md">
        {description}
      </p>

      {/* Optional Button */}
      {buttonText && (
        <div onClick={onButtonClick}>
          <BFLButton
            className="mt-4 flex h-[42px] min-w-[200px] items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#FF6700] to-[#FF8900] px-6 py-3 text-sm font-medium text-white"
            type="button"
          >
            {buttonIcon && (
              <Image
                width={16}
                height={16}
                src={getFullUrl(buttonIcon)}
                alt={buttonIcon ?? ''}
                className="h-4 w-4"
                aria-hidden="true"
              />
            )}
            {buttonText}
          </BFLButton>
        </div>
      )}
    </div>
  );
};

export default NoResultsFound;
